import { render, staticRenderFns } from "./SendToAgencyDialog.vue?vue&type=template&id=6dcffd68&"
import script from "./SendToAgencyDialog.vue?vue&type=script&lang=js&"
export * from "./SendToAgencyDialog.vue?vue&type=script&lang=js&"
import style0 from "./SendToAgencyDialog.vue?vue&type=style&index=0&id=6dcffd68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports